import {addDays, startOfDay} from "@chayka/utils";

export const BOOKING_WIZARD_SLIDES = {
  SUPER_TYPE: "SUPER_TYPE",
  TYPE: "TYPE",
  ROOM_TIME: "ROOM_TIME",
  PARKING: "PARKING",
  EQUIPMENT: "EQUIPMENT",
  CONFIRM: "CONFIRM",
  SUCCESS: "SUCCESS",
} as const;

export type BookingWizardSlide = (typeof BOOKING_WIZARD_SLIDES)[keyof typeof BOOKING_WIZARD_SLIDES];

export const BOOKING_WIZARD_SLIDES_ORDER: BookingWizardSlide[] = [
  BOOKING_WIZARD_SLIDES.SUPER_TYPE,
  BOOKING_WIZARD_SLIDES.TYPE,
  BOOKING_WIZARD_SLIDES.ROOM_TIME,
  BOOKING_WIZARD_SLIDES.PARKING,
  BOOKING_WIZARD_SLIDES.EQUIPMENT,
  BOOKING_WIZARD_SLIDES.CONFIRM,
  BOOKING_WIZARD_SLIDES.SUCCESS,
];

export const BOOKING_WIZARD_SLIDES_TITLES: Record<BookingWizardSlide, string> = {
  [BOOKING_WIZARD_SLIDES.SUPER_TYPE]: "Выберите тип занятия",
  [BOOKING_WIZARD_SLIDES.TYPE]: "Выберите тип занятия",
  [BOOKING_WIZARD_SLIDES.ROOM_TIME]: "Выберите время и зал",
  [BOOKING_WIZARD_SLIDES.PARKING]: "Парковка",
  [BOOKING_WIZARD_SLIDES.EQUIPMENT]: "Аренда оборудования",
  [BOOKING_WIZARD_SLIDES.CONFIRM]: "Подтверждение",
  [BOOKING_WIZARD_SLIDES.SUCCESS]: "Бронирование прошло успешно!",
};

export const PROGRESS_CLASSES_BY_SLIDE: Record<BookingWizardSlide, string> = {
  [BOOKING_WIZARD_SLIDES.SUPER_TYPE]: "w-1/7",
  [BOOKING_WIZARD_SLIDES.TYPE]: "w-2/7",
  [BOOKING_WIZARD_SLIDES.ROOM_TIME]: "w-3/7",
  [BOOKING_WIZARD_SLIDES.PARKING]: "w-4/7",
  [BOOKING_WIZARD_SLIDES.EQUIPMENT]: "w-5/7",
  [BOOKING_WIZARD_SLIDES.CONFIRM]: "w-6/7",
  [BOOKING_WIZARD_SLIDES.SUCCESS]: "w-full",
};

export const MIN_DATE = startOfDay(new Date());
export const MAX_DATE = addDays(MIN_DATE, 30);
